import React, {
  useState,
  useContext,
  useCallback,
  useRef,
  useEffect,
} from "react";
import { createPortal } from "react-dom";
import {
  Row,
  Col,
  Tabs,
  Tab,
  Image,
  Alert,
  FormCheck,
  Button,
  Modal,
  Form,
} from "react-bootstrap";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import { Typeahead, ClearButton } from "react-bootstrap-typeahead";
import { observer } from "mobx-react-lite";
import DataGrid, { Row as GridRow } from "react-data-grid";
import "react-bootstrap-typeahead/css/Typeahead.css";

import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";

import Map from "../components/Map";
import StoryContext from "../store/context";
import { format_time, format_date } from "../utils/formatDate";
import Question from "../components/Question";

const sorted = (A, B) => (A.name < B.name ? -1 : 1);

const getDuration = (par1, par2) => Math.round((par2 - par1) / 60000);

const cor = (n) => (n === 9999999999999 ? 0 : n);

const Meerch = observer(({ store, setCurrentMerch, date, setCenter }) => {
  const columnsEmployee = [
    {
      name: "Мерчендайзер",
      key: "name",
    },
    {
      name: "ВН",
      key: "start_time",
      width: 4,
      formatter({ row }) {
        return <>{format_time(row.start_time)}</>;
      },
    },
    {
      name: "ВК",
      key: "end_time",
      width: 4,
      formatter({ row }) {
        return <>{format_time(row.end_time)}</>;
      },
    },
  ];

  const [currentTeam, setCurrentTeam] = useState(null);

  const onChangeSelect = (item) => {
    if (item[0]) {
      setCurrentTeam(item[0].id);
      store.getMerchs(item[0].id, date);
    } else {
      setCurrentTeam(null);
    }
  };

  const selectMerch = (item) => {
    setCurrentMerch(item);
    store.getVisits(item.uuid, date);
    if (store.route && store.route.visits && store.route.visits.length > 0) {
      setCenter([
        store.route.visits[0].outlet.latitude,
        store.route.visits[0].outlet.longitude,
      ]);
    }
  };

  const arrMerchs = store.merchs
    .map(({ merch, start_time, end_time }) => ({
      uuid: merch.uuid,
      name: merch.name,
      start_time,
      end_time,
    }))
    .slice()
    .sort((s1, s2) => (s1.name.toLowerCase() < s2.name.toLowerCase() ? -1 : 1));

  return (
    <>
      <Typeahead
        onChange={onChangeSelect}
        options={store.teams.map((item) => ({
          id: item.uuid,
          label: item.name,
        }))}
        emptyLabel="Не знайдено..."
        paginationText="Укажіть команду..."
      >
        {({ onClear, selected }) => (
          <div className="rbt-aux">
            {!!selected.length && <ClearButton onClick={onClear} />}
          </div>
        )}
      </Typeahead>
      <DataGrid
        style={{ height: "100%" }}
        columns={columnsEmployee}
        rows={arrMerchs}
        defaultColumnOptions={{
          sortable: true,
          resizable: true,
        }}
        onRowClick={selectMerch}
      />
    </>
  );
});

const TextEditor = ({ row, column }) => {
  return (
    <input
      className="textEditor"
      type="number"
      min={0}
      defaultValue={row[column.key]}
      onChange={(event) =>
        row.set({ ...row, [column.key]: Number(event.target.value) })
      }
      autoFocus
    />
  );
};

const RouteAdd = ({ showAdd, setShowAdd, store, currentMerch }) => {
  const [client, setClient] = useState(null);
  const [outlet, setOutlet] = useState(null);
  const selectClient = (item) => item.length > 0 && setClient(item[0].id);
  const selectOtlet = (item) => item.length > 0 && setOutlet(item[0]);

  const cleerOutlet = (onClear) => {
    // cleerCliet && cleerCliet()
    setClient(null);
    onClear();
  };

  const addOutlet = () => {
    setShowAdd(false);
    store.route.add(outlet, currentMerch.uuid);
  };

  return (
    <Modal show={showAdd} onHide={() => setShowAdd(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Дотати</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Typeahead
          onChange={selectClient}
          options={store.clients
            .filter((item) => item.active === true)
            .sort((s1, s2) =>
              s1.name.toLowerCase() < s2.name.toLowerCase() ? -1 : 1
            )
            .map((item) => ({
              id: item.uuid,
              label: item.name,
            }))}
          emptyLabel="Не знайдено..."
          paginationText="Укажіть команду..."
        >
          {({ onClear, selected }) => (
            <div className="rbt-aux">
              {!!selected.length && <ClearButton onClick={onClear} />}
            </div>
          )}
        </Typeahead>
        <Typeahead
          onChange={selectOtlet}
          options={store.outlets
            .filter(
              (item) =>
                client && item.client.uuid === client && item.active === true
            )
            .sort((s1, s2) =>
              s1.name.toLowerCase() < s2.name.toLowerCase() ? -1 : 1
            )
            .map((item) => ({
              ...item,
              id: item.uuid,
              label: item.name,
            }))}
          emptyLabel="Не знайдено..."
          paginationText="Укажіть команду..."
        >
          {({ onClear, selected }) => (
            <div className="rbt-aux">
              {!!selected.length && <ClearButton onClick={onClear} />}
            </div>
          )}
        </Typeahead>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowAdd(false)}>
          Закрити
        </Button>
        <Button variant="primary" onClick={addOutlet}>
          Зберегти
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const RowRenderer = (props) => {
  return (
    <ContextMenuTrigger
      id="grid-context-menu"
      collect={() => ({ row: props.row })}
    >
      <GridRow {...props} />
    </ContextMenuTrigger>
  );
};

const Routes = observer(({ store, currentMerch, date, setDate, setCenter }) => {
  const [showAdd, setShowAdd] = useState(false);
  const [buttons, setButtons] = useState([]);
  const [trow, setTrow] = useState(null);
  const columnsVisits = [
    {
      name: "Точка",
      key: "name",
      formatter({ row }) {
        return (
          <div
            style={{
              color: row.added ? "red" : "black",
            }}
          >{`${row.outlet.name} (${row.outlet.client.name})`}</div>
        );
      },
    },
    {
      name: "ВН",
      key: "start_time",
      formatter({ row }) {
        return (
          <div
            style={{
              color: row.added ? "red" : "black",
            }}
          >
            {format_time(row.start_time)}
          </div>
        );
      },
      width: 5,
    },
    {
      name: "ВК",
      key: "end_time",
      width: 5,
      formatter({ row }) {
        return (
          <div
            style={{
              color: row.added ? "red" : "black",
            }}
          >
            {format_time(row.end_time)}
          </div>
        );
      },
    },
    {
      name: "Д",
      key: "Duration",
      formatter({ row }) {
        return (
          <div
            style={{
              color: row.added ? "red" : "black",
            }}
          >
            {getDuration(row.start_time, row.end_time)}
          </div>
        );
      },
      width: 5,
    },
  ];

  const onRowDelete = (e, { row }) => {
    setButtons([
      {
        title: "Так",
        click() {
          if (row && store.route) {
            store.route.remove(row);
            setTrow(null);
          }
        },
      },
      { title: "Ні", click: () => {} },
    ]);
  };
  const onRowDeleteAll = () => {
    setButtons([
      {
        title: "Так",
        click() {
          if (store.route) {
            store.route.removeAll();
            setTrow(null);
          }
        },
      },
      { title: "Ні", click: () => {} },
    ]);
  };
  // console.log(JSON.stringify(store.route))

  return (
    <>
      <RouteAdd
        store={store}
        showAdd={showAdd}
        setShowAdd={setShowAdd}
        currentMerch={currentMerch}
      />
      <Question
        show={buttons.length != 0}
        setShow={setButtons}
        text="Видалити ?"
        buttons={buttons || []}
      />
      <Button onClick={() => setShowAdd(true)} style={{ margin: 3 }}>
        Добавить
      </Button>
      <Button
        onClick={() => onRowDelete(null, { row: trow })}
        style={{ margin: 3 }}
      >
        Удалить
      </Button>
      {store.admin === "admin" && (
        <Button onClick={() => onRowDeleteAll()} style={{ margin: 3 }}>
          Удалить все
        </Button>
      )}

      <div>
        <DataGrid
          style={{ height: 600, marginTop: 5 }}
          columns={columnsVisits}
          rows={
            store.route
              ? store.route.visits
                  .slice()
                  .sort((s1, s2) =>
                    s1.outlet.name.toLowerCase() < s2.outlet.name.toLowerCase()
                      ? -1
                      : 1
                  )
              : []
          }
          defaultColumnOptions={{
            sortable: true,
            resizable: true,
          }}
          rowRenderer={RowRenderer}
          onRowClick={(item) => {
            store.route.setCurrent(item);
            store.getFetchPhotoes(item.id);
            setCenter([item.outlet.latitude, item.outlet.longitude]);
            setTrow(item);
          }}
        />
        {createPortal(
          <ContextMenu id="grid-context-menu">
            <MenuItem onClick={onRowDelete}>Видалити ряд</MenuItem>
          </ContextMenu>,
          document.body
        )}
        <Row>
          <Col style={{ width: 100 }}>Всего:</Col>
          <Col>
            {store.route && store.route.visits
              ? format_time(
                  store.route.visits.reduce(
                    (min, item) =>
                      item.start_time === 0
                        ? min
                        : Math.min(item.start_time, min),
                    9999999999999
                  )
                )
              : 0}
          </Col>
          <Col>
            {store.route && store.route.visits
              ? format_time(
                  store.route.visits.reduce(
                    (max, item) => Math.max(max, item.end_time),
                    0
                  )
                )
              : ""}
          </Col>
          <Col>
            {store.route && store.route.visits
              ? store.route.visits.reduce(
                  (sum, item) =>
                    sum + Math.round((item.end_time - item.start_time) / 60000),
                  0
                )
              : 0}
          </Col>
        </Row>
      </div>
      {store.route && (
        <Form>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="formAmount_Hours">
                <Form.Label>Кількість часів</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Кількість часів"
                  value={store.route.amount_hours}
                  onChange={(Event) =>
                    store.route.setAmount_Hours(
                      currentMerch.uuid,
                      Event.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formAmount_Outlets">
                <Form.Label>Кількість точок</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Кількість точок"
                  value={store.route.amount_outlets}
                  onChange={(Event) =>
                    store.route.setAmount_Outlets(
                      currentMerch.uuid,
                      Event.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="formComment">
                <Form.Label>Коментар</Form.Label>
                <Form.Control
                  placeholder="Коментар"
                  value={store.route.comment}
                  onChange={(Event) =>
                    store.route.setComment(
                      currentMerch.uuid,
                      Event.target.value
                    )
                  }
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      )}
    </>
  );
});

const Products = observer(({ store }) => {
  const columnsProducts = [
    {
      name: "Товар",
      key: "product",
      formatter({ row }) {
        return <>{row.product.name}</>;
      },
    },
    {
      name: "Залишок",
      key: "balance",
      formatter({ row }) {
        return <>{row.balance} </>;
      },
      editor: TextEditor,
    },
    {
      name: "Замовлення",
      key: "store",
      formatter({ row }) {
        return <>{row.store} </>;
      },
      editor: TextEditor,
    },
    // {
    //   name: 'Місце',
    //   key: 'possibility',
    //   formatter({row}) {
    //     return <>{row.possibility}</>
    //   },
    //   editor: TextEditor,
    // },
    // {
    //   name: 'Брак',
    //   key: 'defect',
    //   formatter({row}) {
    //     return <>{row.defect}</>
    //   },
    //   editor: TextEditor,
    // },
  ];
  return (
    <>
      <Button
        onClick={() => store.route && store.route.currentvisit.setVisit()}
      >
        Зберегти
      </Button>
      <DataGrid
        style={{ height: 600, marginTop: 5 }}
        columns={columnsProducts}
        rows={
          store.route && store.route.currentvisit
            ? store.route.currentvisit.products
            : []
        }
        defaultColumnOptions={{
          sortable: true,
          resizable: true,
        }}
      />
    </>
  );
});

const Photos = observer(({ store }) => {
  const [photo, setPhoto] = useState(null);

  const click = (itemPhoto) => () => setPhoto(itemPhoto);
  // console.log(photo);

  return (
    <>
      {!photo ? (
        store.photoes.map((item, index) => (
          <Image
            key={index}
            src={`data:image/jpeg;base64,${item}`}
            thumbnail
            width={400}
            onClick={click(item)}
          />
        ))
      ) : (
        <>
          <div
            style={{
              height: 700,
              position: "relative",
              overflow: "hidden",
            }}
          >
            <ReactPanZoom
              image={`data:image/jpeg;base64,${photo}`}
              alt="Image alt text"
            />
          </div>
          <Button onClick={() => setPhoto(null)} style={{ margin: 3 }}>
            Повернутися
          </Button>
        </>
      )}
    </>
  );
});

const Actions = observer(({ store }) => {
  const columnsEmployee = [
    {
      name: "Продукт",
      key: "name",
      formatter({ row }) {
        return <>{row.product.name}</>;
      },
    },
    {
      name: "Дата відвантаження",
      key: "deliverydate",
      formatter({ row }) {
        return <>{row.deliverydate}</>;
      },
    },
    {
      name: "Проведення акції",
      key: "date",
      formatter({ row }) {
        return <>{row.date}</>;
      },
    },
  ];
  return (
    <div
      style={{
        height: 700,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {store?.route?.currentvisit && (
        <DataGrid
          style={{ height: "100%" }}
          columns={columnsEmployee}
          rows={store.route.currentvisit.actions}
          defaultColumnOptions={{
            sortable: true,
            resizable: true,
          }}
        ></DataGrid>
      )}
    </div>
  );
});

const MapVisit = ({ store, center, forceKey }) => {
  const marckers =
    (store.route &&
      store.route.visits &&
      store.route.visits
        .flatMap(
          ({
            outlet,
            start_time,
            end_time,
            start_longitude,
            end_longitude,
            start_latitude,
            end_latitude,
          }) => [
            {
              uuid: outlet.uuid,
              name: outlet.name,
              latitude: outlet.latitude,
              longitude: outlet.longitude,
              color: start_time || end_time ? "blue" : "red",
              is: true,
            },
            {
              uuid: `1${outlet.uuid}1`,
              name: `${outlet.name} - ${format_time(start_time)}`,
              latitude: start_latitude,
              longitude: start_longitude,
              color: "green",
              is: start_latitude !== 0,
            },
            {
              uuid: `2${outlet.uuid}`,
              name: `${outlet.name} - ${format_time(end_time)}`,
              latitude: end_latitude,
              longitude: end_longitude,
              color: "yellow",
              is: end_latitude !== 0,
            },
          ]
        )
        .filter((item) => item.is)) ||
    [];

  return <Map center={center} key={forceKey} zoom={13} marckers={marckers} />;
};

const About = () => {
  const store = useContext(StoryContext);
  const [currentMerch, setCurrentMerch] = useState(null);
  const [center, setCenter] = useState([60, 30]);
  const [date, setDate] = useState(format_date(Date.now()));
  const [activeTab, setActiveTab] = useState("photo");

  return (
    <Row style={{ height: "90vh" }}>
      <Col lg={{ span: 8, order: 1 }} xs={{ span: 12, order: 2 }}>
        <Tabs
          id="p1"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k || "photo")}
          mountOnEnter
        >
          <Tab eventKey="map" title="Карта" style={{ height: "90vh" }}>
            <div style={{ height: 700 }}>
              <MapVisit
                center={center}
                store={store}
                key={+(activeTab === "map")}
              />
            </div>
          </Tab>
          <Tab eventKey="data" title="Дані" style={{ height: "90vh" }}>
            <Products store={store} />
          </Tab>
          <Tab eventKey="photo" title="Фото" style={{ height: "90vh" }}>
            <Photos store={store} />
          </Tab>
          <Tab eventKey="action" title="Акції" style={{ height: "90vh" }}>
            <Actions store={store} />
          </Tab>
        </Tabs>
      </Col>
      <Col lg={{ span: 4, order: 2 }} xs={{ span: 12, order: 1 }}>
        <Alert>{currentMerch ? currentMerch.name : ""}</Alert>
        <input
          name="requested_order_ship_date"
          value={date}
          type="date"
          className="form-control"
          onChange={(event) => setDate(event.target.value)}
        />
        <Tabs defaultActiveKey="merch" id="uncontrolled-tab-example">
          <Tab
            eventKey="merch"
            title="Мерчендайзери"
            style={{ height: "80vh" }}
          >
            <Meerch
              store={store}
              setCurrentMerch={setCurrentMerch}
              date={date}
              setCenter={setCenter}
            />
          </Tab>
          <Tab eventKey="routes" title="Маршрути">
            <Routes
              store={store}
              currentMerch={currentMerch}
              date={date}
              setDate={setDate}
              setCenter={setCenter}
            />
          </Tab>
        </Tabs>
      </Col>
    </Row>
  );
};

export default About;
